import React, { useCallback, useEffect, useState } from "react";
import "./Main.scss";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlusSquare,
  faCheckSquare,
  faPenSquare,
} from "@fortawesome/free-solid-svg-icons";
import { useActions } from "../../../hooks/useActions";
import { useTypeSelector } from "../../../hooks/useTypeSelector";
import { Loader } from "../../../components";
import regions from "./regions";

export const Main = (): JSX.Element => {
  const { statuses, loading } = useTypeSelector((state) => state.statuses);
  const { data: userData } = useTypeSelector((state) => state.user);

  const [region, setRegion] = useState<string>(
    localStorage.getItem("pathologyRegion") || regions[0].value
  );

  const updateRegion = useCallback(
    (region: string) => () => {
      setRegion(region);
      localStorage.setItem("pathologyRegion", region);
    },
    [setRegion]
  );

  const { getStatuses } = useActions();
  useEffect(() => {
    getStatuses();
  }, []);

  if (loading) return <Loader />;
  return (
    <>
      <div className="jumbotron mb-0 pt-4 pb-4">
        <div className="row">
          <div
            className={
              userData?.roles?.includes("validator") ? "col-12" : "col-7"
            }
          >
            <h1 className="display-5">Статистика исследований</h1>
            <hr className="my-4" />
            <div className="badges-info">
              <span className="badge badge-secondary">
                Общее число: {statuses[region]?.count}
              </span>
              <span className="badge badge-primary">
                Размечено: {statuses[region]?.annotated}
              </span>
              <span className="badge badge-success">
                Валидировано: {statuses[region]?.validated}
              </span>
              <span className="badge badge-danger">
                Отказ: {statuses[region]?.deleted}
              </span>
            </div>
          </div>
          {!userData?.roles?.includes("validator") && (
            <div className="col-5">
              <h1 className="display-5">Твоя статистика</h1>
              <hr className="my-4" />
              <div className="badges-info">
                <span className="badge badge-primary">
                  Размечено: {userData.statuses[region]?.count}
                </span>
                <span className="badge badge-success">
                  Правильно: {userData.statuses[region]?.right}
                </span>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="regions">
        <div className="row">
          {regions.map(
            (regionItem) =>
              userData?.groups?.includes(regionItem.value) && (
                <div
                  key={regionItem.value}
                  className={
                    "region " + (region === regionItem.value ? "active" : "")
                  }
                  onClick={updateRegion(regionItem.value)}
                >
                  {regionItem.label}
                </div>
              )
          )}
        </div>
      </div>
      <div className="tile-buttons d-flex justify-content-center flex-wrap align-items-center mt-0">
        <Link
          to={`/upload`}
          style={{ color: "blue" }}
          className="tile-button d-flex justify-content-center flex-wrap align-items-center"
        >
          <FontAwesomeIcon icon={faPlusSquare} />
          <span>Создать иследование</span>
        </Link>
        <Link
          to={`/markup?region=${region}`}
          style={{ color: "purple" }}
          className="tile-button d-flex justify-content-center flex-wrap align-items-center"
        >
          <FontAwesomeIcon icon={faPenSquare} />
          <span>Первичная разметка</span>
        </Link>
        {userData?.roles?.includes("validator") && (
          <Link
            to={`/validate?region=${region}`}
            style={{ color: "green" }}
            className="tile-button d-flex justify-content-center flex-wrap align-items-center"
          >
            <FontAwesomeIcon icon={faCheckSquare} />
            <span>Валидировать иследование</span>
          </Link>
        )}
      </div>
    </>
  );
};
